module.exports = __webpack_public_path__ + "static/finances-web-chart-23c48932c9cb53b457b58aa78e57a424.png";